import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ManagementTeamService } from '../../../../services';
import {  Subscription } from 'rxjs';

@Component({
  selector: 'app-our-team',
  templateUrl: './our-team.component.html',
  styleUrls: ['./our-team.component.css']
})
export class OurTeamComponent implements OnInit {
  modalRef: BsModalRef;
  responseData: any;
  id: number;
  viewDetails:any;
  private subscriptions: Array<Subscription> = [];

  constructor
  (
    private modalService: BsModalService,
    private managementTeamService: ManagementTeamService
  ) { }

  ngOnInit(): void {
    this.getAlldata();
  }

  getAlldata() {
    const data = this.managementTeamService.getAlldata().subscribe((res) => {
      this.responseData = res.map((i) => {
        let link: string;
        if (i.profileLink != null) {
          if (!(/^http[s]?:\/\//.test(i.profileLink))) {
            link = 'https://' + i.profileLink;
          } else {
            link = i.profileLink;
          }
        } else {
          link = null;
        }
        return { ...i, profileLink: link }
      });
    });
    this.subscriptions.push(data)
  }

  showTeamMemberDetail(id: number, template: TemplateRef<any>) {
    this.viewDetails = this.responseData.find(
      (item) => item.id == id
    );

    this.modalRef = this.modalService.show(
      template,
      Object.assign(
        {},
        {
          class:
            'team-member-modal modal-dialog modal-dialog-centered',
        }
      )
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
